import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

const SECTIONS = [
  {
    h: "1. Data We Collect",
    p: "When you use the Intelligent SCM Scan or subscribe to our communications, we collect: your name, email address, company name, job title, industry, company size, and geography; your assessment responses; and payment confirmation details where you purchase a paid report. We do not collect payment card details directly — these are handled by our payment processors.",
  },
  {
    h: "2. How We Use Your Data",
    p: "We use your data to: generate and deliver your assessment results and AI diagnostic report; process payments for paid reports; send you the results and relevant communications you have requested; and improve our frameworks and content. We do not sell or rent your personal data to third parties for marketing purposes.",
  },
  {
    h: "3. Cookies & Similar Technologies",
    p: "SCMBrain uses cookies and similar local-storage technologies to operate the site, remember your session, and understand how the platform is used. Strictly necessary cookies are required for the site to function. Analytics cookies are used only to measure and improve performance. You can control or disable cookies through your browser settings; disabling some cookies may affect site functionality.",
  },
  {
    h: "4. Analytics",
    p: "We may use third-party analytics services (such as Google Analytics 4 and Microsoft Clarity) to collect aggregated, pseudonymous usage information — for example, pages visited, device and browser type, and interaction patterns. This helps us improve the experience. These providers process data under their own privacy policies.",
  },
  {
    h: "5. Third-Party Services",
    p: "We rely on the following third parties to operate SCMBrain: Anthropic (Claude API) to generate your AI diagnostic report from your anonymized assessment scores; Razorpay and Stripe to process payments; and our managed database provider to store your data. Each processes data only as needed to provide their service and under their own privacy and security commitments.",
  },
  {
    h: "6. International Data Processing",
    p: "SCMBrain and its service providers may store and process your data in countries outside your own, including locations where our infrastructure and processors (such as Anthropic, Stripe, and Razorpay) operate. By using the Services, you consent to the transfer and processing of your data in these locations, subject to appropriate safeguards.",
  },
  {
    h: "7. Data Retention",
    p: "We retain your assessment responses and contact details for as long as necessary to deliver results, enable quarterly re-assessment comparisons, and send communications you have opted into, or as required by law. When data is no longer needed, we delete or anonymize it. You may request earlier deletion at any time (see below).",
  },
  {
    h: "8. Security",
    p: "We implement reasonable technical and organizational measures designed to protect your personal data against unauthorized access, loss, or misuse. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security. You use the Services at your own risk.",
  },
  {
    h: "9. Your Rights & Deletion Requests",
    p: "You have the right to access the personal data we hold about you, request correction of inaccurate data, request deletion of your data, and unsubscribe from communications at any time. To exercise any of these rights — including a data deletion request — email us at scmbrainhq@gmail.com with your request. We aim to respond within a reasonable timeframe.",
  },
  {
    h: "10. Contact",
    p: "For any privacy queries or to exercise your data rights, contact us at scmbrainhq@gmail.com.",
  },
];

export default function Privacy() {
  return (
    <Layout>
      <Seo
        title="Privacy Policy | SCMBrain"
        description="How SCMBrain collects, uses, stores, and protects your data — including cookies, analytics, third-party processors, retention, and deletion requests."
        path="/privacy"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">Legal</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B]">Privacy Policy</h1>
        <p className="mt-4 text-[#94A3B8] text-sm">Last updated: February 2026</p>

        <div className="mt-10 space-y-9">
          {SECTIONS.map((c) => (
            <div key={c.h}>
              <h2 className="font-heading text-lg font-bold text-[#1B3A6B] mb-2">{c.h}</h2>
              <p className="text-[#3E577A] leading-relaxed text-[15px]">{c.p}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
